import React, { useState } from 'react'
import { Mutation } from 'react-apollo'
import { message } from 'antd'
import jwt from 'jwt-decode'
import { Link } from 'react-router-dom'
import {
  InputWithLabel, Button, P, Icon,
} from 'konsys-ui'
import {
  Wrapper, LoginWrapper, LoginBox, Image,
} from './styled'
import { LOGIN } from '../../constants/graphql/mutation'
import { theme } from '../../styles/_variables'
import Background from '../../images/login/pdr_background.jpg'
import Logo from '../../images/login/logo.png'
import { setAccessToken, setRefreshToken, saveLocalStorage } from '../../utils/local-data-service'

const { color } = theme

export const Container = () => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const login = (doLogin) => {
    setIsLoading(true)
    doLogin({
      variables: {
        username,
        password,
        client_id: process.env.REACT_APP_CLIENT_ID,
        client_secret: process.env.REACT_APP_CLIENT_SECRET,
        grant_type: process.env.REACT_APP_GRANT_TYPE,
      },
    }).then((resp) => {
      if (resp.data && resp.data.login.success) {
        setIsLoading(false)
        const newToken = resp.data.login.createdAccessToken
        setAccessToken(newToken.access_token)
        setRefreshToken(newToken.refresh_token)
        saveLocalStorage('fullname', `${jwt(newToken.access_token).firstName} ${jwt(newToken.access_token).lastName}`)
        // window.location = getURL().WEB_CMS_SERVER
        window.location = '/home'
      } else if (!resp.loading && !resp.data.login.success) {
        setIsLoading(false)
        message.error(`ไม่สามารถเข้าสู่ระบบได้: ${resp.data.login.message || 'เกิดข้อผิดพลาด'}`)
      }
    })
  }

  return (
    <div>
      <Wrapper bg={Background}></Wrapper>
      <LoginWrapper>
        <Mutation
          mutation={ LOGIN }
        >
          {doLogin => (
            <LoginBox background='#414877'>
              <Image src={Logo} alt='logo' />
              <InputWithLabel
                title={{ text: 'Username', color: theme.color.offWhite }}
                margin='16px 0 0'
                width='100%'
                input={{
                  color: color.offWhite,
                  ghost: true,
                  onKeyDown: (e) => {
                    if (e.keyCode === 13) login(doLogin)
                  },
                  onChange: e => setUsername(e.target.value),
                  prefix: <Icon className='prefix' icon='far fa-user' />,
                }}
              />
              <InputWithLabel
                title={{ text: 'Password', color: theme.color.offWhite }}
                margin='16px'
                width='100%'
                input={{
                  color: color.offWhite,
                  ghost: true,
                  onKeyDown: (e) => {
                    if (e.keyCode === 13) login(doLogin)
                  },
                  type: 'password',
                  onChange: e => setPassword(e.target.value),
                  prefix: <Icon className='prefix' icon='far fa-unlock-alt' />,
                }}
              />
              <Link to='/forgot-password' style={{ alignSelf: 'flex-end', cursor: 'pointer' }} >
                <P bold color={theme.color.offWhite}>Forgot password</P>
              </Link>
              <Button
                margin='16px 0 0'
                color='#C24C4C'
                width='100%'
                inverse
                icon='far fa-sign-in'
                text='เข้าสู่ระบบ'
                disabled={isLoading}
                loading={isLoading}
                onClick={() => {
                  login(doLogin)
                }}
              />
            </LoginBox>
          )}
        </Mutation>
      </LoginWrapper>
    </div>
  )
}

export default Container
